export default __webpack_public_path__ + "static/media/ruler_white.74643c3a.svg";